import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8614c0de")

_pushScopeId("data-v-8614c0de")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "bread_crumbs col-12" }
const _hoisted_4 = { class: "cooki" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "bread_crumbs-line" }, "|", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "cooki" }, " Дайджест ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "bread_crumbs-line" }, "|", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "cooki" }, " 2022 Annual Research: Key Highlights ", -1)
const _hoisted_9 = { class: "digest_info" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "subtitle" }, "2022 Annual Research: Key Highlights", -1)
const _hoisted_11 = { class: "pdf_container" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_pdf = _resolveComponent("pdf")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: { name: 'Main' } }, {
          default: _withId(() => [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('breadCrumbs.main')), 1)
          ]),
          _: 1
        }),
        _hoisted_5,
        _createVNode(_component_router_link, { to: { name: 'digest' } }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _hoisted_7,
        _createVNode(_component_router_link, { to: {} }, {
          default: _withId(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("section", null, [
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_pdf, {
            ref: "myPdfComponent",
            src: _ctx.pdfFile
          }, null, 8, ["src"])
        ])
      ])
    ])
  ]))
})